"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppProvider = void 0;
var react_1 = __importDefault(require("react"));
var AppContext_1 = __importDefault(require("./AppContext"));
exports.AppProvider = function (_a) {
    var _b = _a.initialData, initialData = _b === void 0 ? {} : _b, children = _a.children;
    return react_1.default.createElement(AppContext_1.default.Provider, { value: initialData }, children);
};
//# sourceMappingURL=AppProvider.js.map